import $ from 'jquery';
import { standardizeHeights } from '../../core/INF-gridAlignment';
import { initCollectionCarousel } from './carousel';
import arrowLocation from './arrowLocation';

export default function() {
  $(document).on('shopify:section:load', (e) => {
    const section_id = e.detail.sectionId;

    if ($(`#CollectionCarousel${section_id}`).length > 0) {

      const grid_item_selector = '[data-collection-carousel-slide]';
      const child_selectors = [
        '[data-product-tile-image]',
        '[data-product-tile-title]',
        '[data-product-tile-price]',
      ];
      
      standardizeHeights(grid_item_selector, child_selectors);
      initCollectionCarousel($(`#CollectionCarousel${section_id}`));
      arrowLocation();
    }
  });
}